<template>
  <span></span>
</template>

<script>
export default {
  name: 'Checkmark.vue',
};
</script>

<style scoped>
span {
  display: inline-block;
  transform: rotate(45deg);
  height: 12px;
  width: 5px;
  border-bottom: 3px solid #81C784;
  border-right: 3px solid #81C784;
}
</style>
